import axios from "axios";
import { AppConfig } from "../utilities/AppConfig";
import { PdfDataResponse } from "../definitions/internationalTypes";

export type GetPdfDataParams = {
  id: number;
};

export default async function getPdfData(params: GetPdfDataParams) {
  const { id } = params;
  const { data } = await axios.get<PdfDataResponse>(
    `${AppConfig.API_URL}/pdf_internasional/${id}`,
  );

  return data;
}
